import { Middleware } from '@reduxjs/toolkit'
import { Action } from 'redux'
import {
  IRecentConversationsParams,
  LIST_RECENT_CONVERSATIONS_REQUEST,
  listRecentConversations,
  setThreadsFilter,
} from './channels/actions'
import { aimThreadsFilter } from './profile/selectors'
import { IRootState } from './reducer'

interface IPendingListAction {
  type: unknown
  params?: IRecentConversationsParams
}

const isUnscopedListRequest = (action: unknown): action is IPendingListAction => {
  const candidate = action as IPendingListAction
  return (
    Array.isArray(candidate?.type) &&
    candidate.type[0] === LIST_RECENT_CONVERSATIONS_REQUEST &&
    candidate.params?.filter === undefined
  )
}

/**
 * The Threads list is refetched from a dozen places (socket frames, mute expiry,
 * focus), none of which should have to know the filter or how far "Show more" has
 * grown the window. A bare refetch picks both up here, before apiMiddleware runs it.
 */
const threadsWindowMiddleware =
  (): Middleware<object, IRootState> => (store) => (next) => (action) => {
    if (!isUnscopedListRequest(action)) return next(action)

    // Pinned on first use, so a response can be matched against the filter in effect.
    if (store.getState().channels.recentConversations.filter === null) {
      store.dispatch(setThreadsFilter(aimThreadsFilter(store.getState())))
    }

    const state = store.getState()
    const { filter, recentCount } = state.channels.recentConversations
    return store.dispatch(
      listRecentConversations({
        ...action.params,
        filter: filter ?? aimThreadsFilter(state),
        recentCount,
      }) as unknown as Action,
    )
  }

export default threadsWindowMiddleware
